/* eslint-disable @typescript-eslint/no-namespace, @typescript-eslint/array-type, @typescript-eslint/no-explicit-any, @typescript-eslint/ban-types, @typescript-eslint/consistent-indexed-object-style, @typescript-eslint/no-redundant-type-constituents */
// @ts-nocheck
// THIS FILE IS GENERATED, DO NOT EDIT!
import type * as Types from './types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type EhrSyncConnectionFieldsFragment = { __typename?: 'EhrSyncConnection', id: string, ehr_connection_id: string, qie_zone_name?: string | null, ehr_environment?: Types.EhrEnvironment | null, registry_state?: Types.EhrSyncRegistryState | null, last_received_at?: string | null, organization_id: string, organization_name: string, network?: string | null, ehr_vendor?: Types.EhrVendor | null, environment_label?: string | null, description?: string | null, status: Types.EhrSyncConnectionStatus, last_sync_at?: string | null, go_live_label?: string | null, patient_count?: number | null, review_count?: number | null, record_count: number, completed_count: number, error_count: number, created_at?: string | null, modified_at?: string | null, error_summary?: { __typename?: 'EhrSyncConnectionError', title: string, body: string } | null, resources: Array<{ __typename?: 'EhrSyncResource', channel_id?: string | null, channel_name: string, resource_type: string, direction?: Types.EhrSyncDirection | null, state?: Types.EhrSyncResourceState | null, state_description?: string | null, is_enabled?: boolean | null, received_count?: number | null, completed_count?: number | null, error_queue?: number | null, inbound_queue?: number | null, outbound_queue?: number | null, processing_queue?: number | null, last_received_at?: string | null, last_error_at?: string | null, stopped_nodes?: Array<string> | null, scope?: string | null, gated?: boolean | null, ehr_sync_resource_id?: string | null, enabled: boolean, policy_state: Types.EhrSyncResourcePolicyState, policy_updated_at?: string | null }>, history?: Array<{ __typename?: 'EhrSyncRun', at: string, trigger: string, result: Types.EhrSyncResult, duration_label?: string | null, detail?: string | null }> | null };

export type ListEhrSyncConnectionsQueryVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.ListEhrSyncConnectionsInput>;
}>;


export type ListEhrSyncConnectionsQuery = { __typename?: 'Query', listEhrSyncConnections: Array<{ __typename?: 'EhrSyncConnection', id: string, ehr_connection_id: string, qie_zone_name?: string | null, ehr_environment?: Types.EhrEnvironment | null, registry_state?: Types.EhrSyncRegistryState | null, last_received_at?: string | null, organization_id: string, organization_name: string, network?: string | null, ehr_vendor?: Types.EhrVendor | null, environment_label?: string | null, description?: string | null, status: Types.EhrSyncConnectionStatus, last_sync_at?: string | null, go_live_label?: string | null, patient_count?: number | null, review_count?: number | null, record_count: number, completed_count: number, error_count: number, created_at?: string | null, modified_at?: string | null, error_summary?: { __typename?: 'EhrSyncConnectionError', title: string, body: string } | null, resources: Array<{ __typename?: 'EhrSyncResource', channel_id?: string | null, channel_name: string, resource_type: string, direction?: Types.EhrSyncDirection | null, state?: Types.EhrSyncResourceState | null, state_description?: string | null, is_enabled?: boolean | null, received_count?: number | null, completed_count?: number | null, error_queue?: number | null, inbound_queue?: number | null, outbound_queue?: number | null, processing_queue?: number | null, last_received_at?: string | null, last_error_at?: string | null, stopped_nodes?: Array<string> | null, scope?: string | null, gated?: boolean | null, ehr_sync_resource_id?: string | null, enabled: boolean, policy_state: Types.EhrSyncResourcePolicyState, policy_updated_at?: string | null }>, history?: Array<{ __typename?: 'EhrSyncRun', at: string, trigger: string, result: Types.EhrSyncResult, duration_label?: string | null, detail?: string | null }> | null }> };

export type GetEhrSyncConnectionQueryVariables = Types.Exact<{
  input: Types.GetEhrSyncConnectionInput;
}>;


export type GetEhrSyncConnectionQuery = { __typename?: 'Query', getEhrSyncConnection?: { __typename?: 'EhrSyncConnection', id: string, ehr_connection_id: string, qie_zone_name?: string | null, ehr_environment?: Types.EhrEnvironment | null, registry_state?: Types.EhrSyncRegistryState | null, last_received_at?: string | null, organization_id: string, organization_name: string, network?: string | null, ehr_vendor?: Types.EhrVendor | null, environment_label?: string | null, description?: string | null, status: Types.EhrSyncConnectionStatus, last_sync_at?: string | null, go_live_label?: string | null, patient_count?: number | null, review_count?: number | null, record_count: number, completed_count: number, error_count: number, created_at?: string | null, modified_at?: string | null, error_summary?: { __typename?: 'EhrSyncConnectionError', title: string, body: string } | null, resources: Array<{ __typename?: 'EhrSyncResource', channel_id?: string | null, channel_name: string, resource_type: string, direction?: Types.EhrSyncDirection | null, state?: Types.EhrSyncResourceState | null, state_description?: string | null, is_enabled?: boolean | null, received_count?: number | null, completed_count?: number | null, error_queue?: number | null, inbound_queue?: number | null, outbound_queue?: number | null, processing_queue?: number | null, last_received_at?: string | null, last_error_at?: string | null, stopped_nodes?: Array<string> | null, scope?: string | null, gated?: boolean | null, ehr_sync_resource_id?: string | null, enabled: boolean, policy_state: Types.EhrSyncResourcePolicyState, policy_updated_at?: string | null }>, history?: Array<{ __typename?: 'EhrSyncRun', at: string, trigger: string, result: Types.EhrSyncResult, duration_label?: string | null, detail?: string | null }> | null } | null };

export type UpsertEhrSyncResourceMutationVariables = Types.Exact<{
  input: Types.UpsertEhrSyncResourceInput;
}>;


export type UpsertEhrSyncResourceMutation = { __typename?: 'Mutation', upsertEhrSyncResource: { __typename?: 'EhrSyncResourceConfig', id: string, resource_type: string, enabled: boolean, updated_at: string } };

export type EhrPatientSummaryFieldsFragment = { __typename?: 'EhrSyncPatientSummary', vitall_patient_id: string, first_name?: string | null, last_name?: string | null, vitall_user_id?: number | null, birth_date?: string | null, gender?: string | null };

export type EhrPatientLinkFieldsFragment = { __typename?: 'EhrPatientLink', id: string, ehr_connection_id: string, vitall_patient_id: string, external_patient_id?: string | null, status: Types.EhrPatientLinkStatus, match_score?: number | null, match_algorithm?: string | null, enrolled_by_name?: string | null, reviewed_by_name?: string | null, reviewed_at?: string | null, created_at: string, updated_at: string, patient?: { __typename?: 'EhrSyncPatientSummary', vitall_patient_id: string, first_name?: string | null, last_name?: string | null, vitall_user_id?: number | null, birth_date?: string | null, gender?: string | null } | null };

export type EhrSyncPatientLinksQueryVariables = Types.Exact<{
  input: Types.EhrConnectionRefInput;
}>;


export type EhrSyncPatientLinksQuery = { __typename?: 'Query', ehrSyncPatientLinks: Array<{ __typename?: 'EhrPatientLink', id: string, ehr_connection_id: string, vitall_patient_id: string, external_patient_id?: string | null, status: Types.EhrPatientLinkStatus, match_score?: number | null, match_algorithm?: string | null, enrolled_by_name?: string | null, reviewed_by_name?: string | null, reviewed_at?: string | null, created_at: string, updated_at: string, patient?: { __typename?: 'EhrSyncPatientSummary', vitall_patient_id: string, first_name?: string | null, last_name?: string | null, vitall_user_id?: number | null, birth_date?: string | null, gender?: string | null } | null }> };

export type EhrSyncEnrollCandidatesQueryVariables = Types.Exact<{
  input: Types.EhrSyncEnrollCandidatesInput;
}>;


export type EhrSyncEnrollCandidatesQuery = { __typename?: 'Query', ehrSyncEnrollCandidates: Array<{ __typename?: 'EhrSyncEnrollCandidate', already_enrolled: boolean, patient: { __typename?: 'EhrSyncPatientSummary', vitall_patient_id: string, first_name?: string | null, last_name?: string | null, vitall_user_id?: number | null, birth_date?: string | null, gender?: string | null } }> };

export type EnrollEhrSyncPatientMutationVariables = Types.Exact<{
  input: Types.EnrollEhrSyncPatientInput;
}>;


export type EnrollEhrSyncPatientMutation = { __typename?: 'Mutation', enrollEhrSyncPatient: { __typename?: 'EhrPatientLink', id: string, status: Types.EhrPatientLinkStatus } };

export type SetEhrPatientLinkPausedMutationVariables = Types.Exact<{
  input: Types.SetEhrPatientLinkPausedInput;
}>;


export type SetEhrPatientLinkPausedMutation = { __typename?: 'Mutation', setEhrPatientLinkPaused: { __typename?: 'EhrPatientLink', id: string, status: Types.EhrPatientLinkStatus } };

export type UnenrollEhrSyncPatientMutationVariables = Types.Exact<{
  input: Types.EhrPatientLinkRefInput;
}>;


export type UnenrollEhrSyncPatientMutation = { __typename?: 'Mutation', unenrollEhrSyncPatient: boolean };

export type CheckEhrZoneQueryVariables = Types.Exact<{
  input: Types.CheckEhrZoneInput;
}>;


export type CheckEhrZoneQuery = { __typename?: 'Query', checkEhrZone: { __typename?: 'EhrZoneCheck', qie_zone_name: string, result: Types.EhrZoneCheckResult, zone_prefix?: string | null, qie_zone_id?: string | null, channel_count?: number | null, registered_account_name?: string | null } };

export type RegisterEhrConnectionMutationVariables = Types.Exact<{
  input: Types.RegisterEhrConnectionInput;
}>;


export type RegisterEhrConnectionMutation = { __typename?: 'Mutation', registerEhrConnection: { __typename?: 'EhrConnection', ehr_connection_id: string, qie_zone_name: string, status: Types.EhrConnectionStatus } };

export type ListEhrPatientLinksForReviewQueryVariables = Types.Exact<{
  input: Types.EhrConnectionRefInput;
}>;


export type ListEhrPatientLinksForReviewQuery = { __typename?: 'Query', listEhrPatientLinksForReview: Array<{ __typename?: 'EhrReviewCase', matched_at: string, algorithm?: string | null, best_score?: number | null, auto_link_threshold: number, no_match_threshold: number, link: { __typename?: 'EhrPatientLink', id: string, ehr_connection_id: string, vitall_patient_id: string, external_patient_id?: string | null, status: Types.EhrPatientLinkStatus, match_score?: number | null, match_algorithm?: string | null, enrolled_by_name?: string | null, reviewed_by_name?: string | null, reviewed_at?: string | null, created_at: string, updated_at: string, patient?: { __typename?: 'EhrSyncPatientSummary', vitall_patient_id: string, first_name?: string | null, last_name?: string | null, vitall_user_id?: number | null, birth_date?: string | null, gender?: string | null } | null }, subject: Array<{ __typename?: 'EhrMatchSubjectValue', field: Types.EhrMatchField, value?: string | null }>, candidates: Array<{ __typename?: 'EhrMatchCandidate', external_patient_id: string, score: number, fields: Array<{ __typename?: 'EhrMatchFieldEvidence', field: Types.EhrMatchField, value?: string | null, result: Types.EhrMatchFieldResult }> }> }> };

export type ReviewEhrPatientLinkMutationVariables = Types.Exact<{
  input: Types.ReviewEhrPatientLinkInput;
}>;


export type ReviewEhrPatientLinkMutation = { __typename?: 'Mutation', reviewEhrPatientLink: { __typename?: 'EhrPatientLink', id: string, status: Types.EhrPatientLinkStatus } };

export const EhrSyncConnectionFieldsFragmentDoc = gql`
    fragment EhrSyncConnectionFields on EhrSyncConnection {
  id
  ehr_connection_id
  qie_zone_name
  ehr_environment
  registry_state
  last_received_at
  organization_id
  organization_name
  network
  ehr_vendor
  environment_label
  description
  status
  last_sync_at
  go_live_label
  patient_count
  review_count
  record_count
  completed_count
  error_count
  created_at
  modified_at
  error_summary {
    title
    body
  }
  resources {
    channel_id
    channel_name
    resource_type
    direction
    state
    state_description
    is_enabled
    received_count
    completed_count
    error_queue
    inbound_queue
    outbound_queue
    processing_queue
    last_received_at
    last_error_at
    stopped_nodes
    scope
    gated
    ehr_sync_resource_id
    enabled
    policy_state
    policy_updated_at
  }
  history {
    at
    trigger
    result
    duration_label
    detail
  }
}
    `;
export const EhrPatientSummaryFieldsFragmentDoc = gql`
    fragment EhrPatientSummaryFields on EhrSyncPatientSummary {
  vitall_patient_id
  first_name
  last_name
  vitall_user_id
  birth_date
  gender
}
    `;
export const EhrPatientLinkFieldsFragmentDoc = gql`
    fragment EhrPatientLinkFields on EhrPatientLink {
  id
  ehr_connection_id
  vitall_patient_id
  external_patient_id
  status
  match_score
  match_algorithm
  enrolled_by_name
  reviewed_by_name
  reviewed_at
  created_at
  updated_at
  patient {
    ...EhrPatientSummaryFields
  }
}
    ${EhrPatientSummaryFieldsFragmentDoc}`;
export const ListEhrSyncConnectionsDocument = gql`
    query listEhrSyncConnections($input: ListEhrSyncConnectionsInput) {
  listEhrSyncConnections(input: $input) {
    ...EhrSyncConnectionFields
  }
}
    ${EhrSyncConnectionFieldsFragmentDoc}`;
export function useListEhrSyncConnectionsQuery(baseOptions?: Apollo.QueryHookOptions<ListEhrSyncConnectionsQuery, ListEhrSyncConnectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListEhrSyncConnectionsQuery, ListEhrSyncConnectionsQueryVariables>(ListEhrSyncConnectionsDocument, options);
      }
export function useListEhrSyncConnectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListEhrSyncConnectionsQuery, ListEhrSyncConnectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListEhrSyncConnectionsQuery, ListEhrSyncConnectionsQueryVariables>(ListEhrSyncConnectionsDocument, options);
        }
// @ts-ignore
export function useListEhrSyncConnectionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListEhrSyncConnectionsQuery, ListEhrSyncConnectionsQueryVariables>): Apollo.UseSuspenseQueryResult<ListEhrSyncConnectionsQuery, ListEhrSyncConnectionsQueryVariables>;
export function useListEhrSyncConnectionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListEhrSyncConnectionsQuery, ListEhrSyncConnectionsQueryVariables>): Apollo.UseSuspenseQueryResult<ListEhrSyncConnectionsQuery | undefined, ListEhrSyncConnectionsQueryVariables>;
export function useListEhrSyncConnectionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListEhrSyncConnectionsQuery, ListEhrSyncConnectionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListEhrSyncConnectionsQuery, ListEhrSyncConnectionsQueryVariables>(ListEhrSyncConnectionsDocument, options);
        }
export type ListEhrSyncConnectionsQueryHookResult = ReturnType<typeof useListEhrSyncConnectionsQuery>;
export type ListEhrSyncConnectionsLazyQueryHookResult = ReturnType<typeof useListEhrSyncConnectionsLazyQuery>;
export type ListEhrSyncConnectionsSuspenseQueryHookResult = ReturnType<typeof useListEhrSyncConnectionsSuspenseQuery>;
export type ListEhrSyncConnectionsQueryResult = Apollo.QueryResult<ListEhrSyncConnectionsQuery, ListEhrSyncConnectionsQueryVariables>;
export const GetEhrSyncConnectionDocument = gql`
    query getEhrSyncConnection($input: GetEhrSyncConnectionInput!) {
  getEhrSyncConnection(input: $input) {
    ...EhrSyncConnectionFields
  }
}
    ${EhrSyncConnectionFieldsFragmentDoc}`;
export function useGetEhrSyncConnectionQuery(baseOptions: Apollo.QueryHookOptions<GetEhrSyncConnectionQuery, GetEhrSyncConnectionQueryVariables> & ({ variables: GetEhrSyncConnectionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEhrSyncConnectionQuery, GetEhrSyncConnectionQueryVariables>(GetEhrSyncConnectionDocument, options);
      }
export function useGetEhrSyncConnectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEhrSyncConnectionQuery, GetEhrSyncConnectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEhrSyncConnectionQuery, GetEhrSyncConnectionQueryVariables>(GetEhrSyncConnectionDocument, options);
        }
// @ts-ignore
export function useGetEhrSyncConnectionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetEhrSyncConnectionQuery, GetEhrSyncConnectionQueryVariables>): Apollo.UseSuspenseQueryResult<GetEhrSyncConnectionQuery, GetEhrSyncConnectionQueryVariables>;
export function useGetEhrSyncConnectionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEhrSyncConnectionQuery, GetEhrSyncConnectionQueryVariables>): Apollo.UseSuspenseQueryResult<GetEhrSyncConnectionQuery | undefined, GetEhrSyncConnectionQueryVariables>;
export function useGetEhrSyncConnectionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEhrSyncConnectionQuery, GetEhrSyncConnectionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEhrSyncConnectionQuery, GetEhrSyncConnectionQueryVariables>(GetEhrSyncConnectionDocument, options);
        }
export type GetEhrSyncConnectionQueryHookResult = ReturnType<typeof useGetEhrSyncConnectionQuery>;
export type GetEhrSyncConnectionLazyQueryHookResult = ReturnType<typeof useGetEhrSyncConnectionLazyQuery>;
export type GetEhrSyncConnectionSuspenseQueryHookResult = ReturnType<typeof useGetEhrSyncConnectionSuspenseQuery>;
export type GetEhrSyncConnectionQueryResult = Apollo.QueryResult<GetEhrSyncConnectionQuery, GetEhrSyncConnectionQueryVariables>;
export const UpsertEhrSyncResourceDocument = gql`
    mutation upsertEhrSyncResource($input: UpsertEhrSyncResourceInput!) {
  upsertEhrSyncResource(input: $input) {
    id
    resource_type
    enabled
    updated_at
  }
}
    `;
export type UpsertEhrSyncResourceMutationFn = Apollo.MutationFunction<UpsertEhrSyncResourceMutation, UpsertEhrSyncResourceMutationVariables>;
export function useUpsertEhrSyncResourceMutation(baseOptions?: Apollo.MutationHookOptions<UpsertEhrSyncResourceMutation, UpsertEhrSyncResourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertEhrSyncResourceMutation, UpsertEhrSyncResourceMutationVariables>(UpsertEhrSyncResourceDocument, options);
      }
export type UpsertEhrSyncResourceMutationHookResult = ReturnType<typeof useUpsertEhrSyncResourceMutation>;
export type UpsertEhrSyncResourceMutationResult = Apollo.MutationResult<UpsertEhrSyncResourceMutation>;
export type UpsertEhrSyncResourceMutationOptions = Apollo.BaseMutationOptions<UpsertEhrSyncResourceMutation, UpsertEhrSyncResourceMutationVariables>;
export const EhrSyncPatientLinksDocument = gql`
    query ehrSyncPatientLinks($input: EhrConnectionRefInput!) {
  ehrSyncPatientLinks(input: $input) {
    ...EhrPatientLinkFields
  }
}
    ${EhrPatientLinkFieldsFragmentDoc}`;
export function useEhrSyncPatientLinksQuery(baseOptions: Apollo.QueryHookOptions<EhrSyncPatientLinksQuery, EhrSyncPatientLinksQueryVariables> & ({ variables: EhrSyncPatientLinksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EhrSyncPatientLinksQuery, EhrSyncPatientLinksQueryVariables>(EhrSyncPatientLinksDocument, options);
      }
export function useEhrSyncPatientLinksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EhrSyncPatientLinksQuery, EhrSyncPatientLinksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EhrSyncPatientLinksQuery, EhrSyncPatientLinksQueryVariables>(EhrSyncPatientLinksDocument, options);
        }
// @ts-ignore
export function useEhrSyncPatientLinksSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EhrSyncPatientLinksQuery, EhrSyncPatientLinksQueryVariables>): Apollo.UseSuspenseQueryResult<EhrSyncPatientLinksQuery, EhrSyncPatientLinksQueryVariables>;
export function useEhrSyncPatientLinksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EhrSyncPatientLinksQuery, EhrSyncPatientLinksQueryVariables>): Apollo.UseSuspenseQueryResult<EhrSyncPatientLinksQuery | undefined, EhrSyncPatientLinksQueryVariables>;
export function useEhrSyncPatientLinksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EhrSyncPatientLinksQuery, EhrSyncPatientLinksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EhrSyncPatientLinksQuery, EhrSyncPatientLinksQueryVariables>(EhrSyncPatientLinksDocument, options);
        }
export type EhrSyncPatientLinksQueryHookResult = ReturnType<typeof useEhrSyncPatientLinksQuery>;
export type EhrSyncPatientLinksLazyQueryHookResult = ReturnType<typeof useEhrSyncPatientLinksLazyQuery>;
export type EhrSyncPatientLinksSuspenseQueryHookResult = ReturnType<typeof useEhrSyncPatientLinksSuspenseQuery>;
export type EhrSyncPatientLinksQueryResult = Apollo.QueryResult<EhrSyncPatientLinksQuery, EhrSyncPatientLinksQueryVariables>;
export const EhrSyncEnrollCandidatesDocument = gql`
    query ehrSyncEnrollCandidates($input: EhrSyncEnrollCandidatesInput!) {
  ehrSyncEnrollCandidates(input: $input) {
    already_enrolled
    patient {
      ...EhrPatientSummaryFields
    }
  }
}
    ${EhrPatientSummaryFieldsFragmentDoc}`;
export function useEhrSyncEnrollCandidatesQuery(baseOptions: Apollo.QueryHookOptions<EhrSyncEnrollCandidatesQuery, EhrSyncEnrollCandidatesQueryVariables> & ({ variables: EhrSyncEnrollCandidatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EhrSyncEnrollCandidatesQuery, EhrSyncEnrollCandidatesQueryVariables>(EhrSyncEnrollCandidatesDocument, options);
      }
export function useEhrSyncEnrollCandidatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EhrSyncEnrollCandidatesQuery, EhrSyncEnrollCandidatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EhrSyncEnrollCandidatesQuery, EhrSyncEnrollCandidatesQueryVariables>(EhrSyncEnrollCandidatesDocument, options);
        }
// @ts-ignore
export function useEhrSyncEnrollCandidatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EhrSyncEnrollCandidatesQuery, EhrSyncEnrollCandidatesQueryVariables>): Apollo.UseSuspenseQueryResult<EhrSyncEnrollCandidatesQuery, EhrSyncEnrollCandidatesQueryVariables>;
export function useEhrSyncEnrollCandidatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EhrSyncEnrollCandidatesQuery, EhrSyncEnrollCandidatesQueryVariables>): Apollo.UseSuspenseQueryResult<EhrSyncEnrollCandidatesQuery | undefined, EhrSyncEnrollCandidatesQueryVariables>;
export function useEhrSyncEnrollCandidatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EhrSyncEnrollCandidatesQuery, EhrSyncEnrollCandidatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EhrSyncEnrollCandidatesQuery, EhrSyncEnrollCandidatesQueryVariables>(EhrSyncEnrollCandidatesDocument, options);
        }
export type EhrSyncEnrollCandidatesQueryHookResult = ReturnType<typeof useEhrSyncEnrollCandidatesQuery>;
export type EhrSyncEnrollCandidatesLazyQueryHookResult = ReturnType<typeof useEhrSyncEnrollCandidatesLazyQuery>;
export type EhrSyncEnrollCandidatesSuspenseQueryHookResult = ReturnType<typeof useEhrSyncEnrollCandidatesSuspenseQuery>;
export type EhrSyncEnrollCandidatesQueryResult = Apollo.QueryResult<EhrSyncEnrollCandidatesQuery, EhrSyncEnrollCandidatesQueryVariables>;
export const EnrollEhrSyncPatientDocument = gql`
    mutation enrollEhrSyncPatient($input: EnrollEhrSyncPatientInput!) {
  enrollEhrSyncPatient(input: $input) {
    id
    status
  }
}
    `;
export type EnrollEhrSyncPatientMutationFn = Apollo.MutationFunction<EnrollEhrSyncPatientMutation, EnrollEhrSyncPatientMutationVariables>;
export function useEnrollEhrSyncPatientMutation(baseOptions?: Apollo.MutationHookOptions<EnrollEhrSyncPatientMutation, EnrollEhrSyncPatientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EnrollEhrSyncPatientMutation, EnrollEhrSyncPatientMutationVariables>(EnrollEhrSyncPatientDocument, options);
      }
export type EnrollEhrSyncPatientMutationHookResult = ReturnType<typeof useEnrollEhrSyncPatientMutation>;
export type EnrollEhrSyncPatientMutationResult = Apollo.MutationResult<EnrollEhrSyncPatientMutation>;
export type EnrollEhrSyncPatientMutationOptions = Apollo.BaseMutationOptions<EnrollEhrSyncPatientMutation, EnrollEhrSyncPatientMutationVariables>;
export const SetEhrPatientLinkPausedDocument = gql`
    mutation setEhrPatientLinkPaused($input: SetEhrPatientLinkPausedInput!) {
  setEhrPatientLinkPaused(input: $input) {
    id
    status
  }
}
    `;
export type SetEhrPatientLinkPausedMutationFn = Apollo.MutationFunction<SetEhrPatientLinkPausedMutation, SetEhrPatientLinkPausedMutationVariables>;
export function useSetEhrPatientLinkPausedMutation(baseOptions?: Apollo.MutationHookOptions<SetEhrPatientLinkPausedMutation, SetEhrPatientLinkPausedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetEhrPatientLinkPausedMutation, SetEhrPatientLinkPausedMutationVariables>(SetEhrPatientLinkPausedDocument, options);
      }
export type SetEhrPatientLinkPausedMutationHookResult = ReturnType<typeof useSetEhrPatientLinkPausedMutation>;
export type SetEhrPatientLinkPausedMutationResult = Apollo.MutationResult<SetEhrPatientLinkPausedMutation>;
export type SetEhrPatientLinkPausedMutationOptions = Apollo.BaseMutationOptions<SetEhrPatientLinkPausedMutation, SetEhrPatientLinkPausedMutationVariables>;
export const UnenrollEhrSyncPatientDocument = gql`
    mutation unenrollEhrSyncPatient($input: EhrPatientLinkRefInput!) {
  unenrollEhrSyncPatient(input: $input)
}
    `;
export type UnenrollEhrSyncPatientMutationFn = Apollo.MutationFunction<UnenrollEhrSyncPatientMutation, UnenrollEhrSyncPatientMutationVariables>;
export function useUnenrollEhrSyncPatientMutation(baseOptions?: Apollo.MutationHookOptions<UnenrollEhrSyncPatientMutation, UnenrollEhrSyncPatientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnenrollEhrSyncPatientMutation, UnenrollEhrSyncPatientMutationVariables>(UnenrollEhrSyncPatientDocument, options);
      }
export type UnenrollEhrSyncPatientMutationHookResult = ReturnType<typeof useUnenrollEhrSyncPatientMutation>;
export type UnenrollEhrSyncPatientMutationResult = Apollo.MutationResult<UnenrollEhrSyncPatientMutation>;
export type UnenrollEhrSyncPatientMutationOptions = Apollo.BaseMutationOptions<UnenrollEhrSyncPatientMutation, UnenrollEhrSyncPatientMutationVariables>;
export const CheckEhrZoneDocument = gql`
    query checkEhrZone($input: CheckEhrZoneInput!) {
  checkEhrZone(input: $input) {
    qie_zone_name
    result
    zone_prefix
    qie_zone_id
    channel_count
    registered_account_name
  }
}
    `;
export function useCheckEhrZoneQuery(baseOptions: Apollo.QueryHookOptions<CheckEhrZoneQuery, CheckEhrZoneQueryVariables> & ({ variables: CheckEhrZoneQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckEhrZoneQuery, CheckEhrZoneQueryVariables>(CheckEhrZoneDocument, options);
      }
export function useCheckEhrZoneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckEhrZoneQuery, CheckEhrZoneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckEhrZoneQuery, CheckEhrZoneQueryVariables>(CheckEhrZoneDocument, options);
        }
// @ts-ignore
export function useCheckEhrZoneSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CheckEhrZoneQuery, CheckEhrZoneQueryVariables>): Apollo.UseSuspenseQueryResult<CheckEhrZoneQuery, CheckEhrZoneQueryVariables>;
export function useCheckEhrZoneSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CheckEhrZoneQuery, CheckEhrZoneQueryVariables>): Apollo.UseSuspenseQueryResult<CheckEhrZoneQuery | undefined, CheckEhrZoneQueryVariables>;
export function useCheckEhrZoneSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CheckEhrZoneQuery, CheckEhrZoneQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CheckEhrZoneQuery, CheckEhrZoneQueryVariables>(CheckEhrZoneDocument, options);
        }
export type CheckEhrZoneQueryHookResult = ReturnType<typeof useCheckEhrZoneQuery>;
export type CheckEhrZoneLazyQueryHookResult = ReturnType<typeof useCheckEhrZoneLazyQuery>;
export type CheckEhrZoneSuspenseQueryHookResult = ReturnType<typeof useCheckEhrZoneSuspenseQuery>;
export type CheckEhrZoneQueryResult = Apollo.QueryResult<CheckEhrZoneQuery, CheckEhrZoneQueryVariables>;
export const RegisterEhrConnectionDocument = gql`
    mutation registerEhrConnection($input: RegisterEhrConnectionInput!) {
  registerEhrConnection(input: $input) {
    ehr_connection_id
    qie_zone_name
    status
  }
}
    `;
export type RegisterEhrConnectionMutationFn = Apollo.MutationFunction<RegisterEhrConnectionMutation, RegisterEhrConnectionMutationVariables>;
export function useRegisterEhrConnectionMutation(baseOptions?: Apollo.MutationHookOptions<RegisterEhrConnectionMutation, RegisterEhrConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterEhrConnectionMutation, RegisterEhrConnectionMutationVariables>(RegisterEhrConnectionDocument, options);
      }
export type RegisterEhrConnectionMutationHookResult = ReturnType<typeof useRegisterEhrConnectionMutation>;
export type RegisterEhrConnectionMutationResult = Apollo.MutationResult<RegisterEhrConnectionMutation>;
export type RegisterEhrConnectionMutationOptions = Apollo.BaseMutationOptions<RegisterEhrConnectionMutation, RegisterEhrConnectionMutationVariables>;
export const ListEhrPatientLinksForReviewDocument = gql`
    query listEhrPatientLinksForReview($input: EhrConnectionRefInput!) {
  listEhrPatientLinksForReview(input: $input) {
    link {
      ...EhrPatientLinkFields
    }
    matched_at
    algorithm
    best_score
    auto_link_threshold
    no_match_threshold
    subject {
      field
      value
    }
    candidates {
      external_patient_id
      score
      fields {
        field
        value
        result
      }
    }
  }
}
    ${EhrPatientLinkFieldsFragmentDoc}`;
export function useListEhrPatientLinksForReviewQuery(baseOptions: Apollo.QueryHookOptions<ListEhrPatientLinksForReviewQuery, ListEhrPatientLinksForReviewQueryVariables> & ({ variables: ListEhrPatientLinksForReviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListEhrPatientLinksForReviewQuery, ListEhrPatientLinksForReviewQueryVariables>(ListEhrPatientLinksForReviewDocument, options);
      }
export function useListEhrPatientLinksForReviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListEhrPatientLinksForReviewQuery, ListEhrPatientLinksForReviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListEhrPatientLinksForReviewQuery, ListEhrPatientLinksForReviewQueryVariables>(ListEhrPatientLinksForReviewDocument, options);
        }
// @ts-ignore
export function useListEhrPatientLinksForReviewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListEhrPatientLinksForReviewQuery, ListEhrPatientLinksForReviewQueryVariables>): Apollo.UseSuspenseQueryResult<ListEhrPatientLinksForReviewQuery, ListEhrPatientLinksForReviewQueryVariables>;
export function useListEhrPatientLinksForReviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListEhrPatientLinksForReviewQuery, ListEhrPatientLinksForReviewQueryVariables>): Apollo.UseSuspenseQueryResult<ListEhrPatientLinksForReviewQuery | undefined, ListEhrPatientLinksForReviewQueryVariables>;
export function useListEhrPatientLinksForReviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListEhrPatientLinksForReviewQuery, ListEhrPatientLinksForReviewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListEhrPatientLinksForReviewQuery, ListEhrPatientLinksForReviewQueryVariables>(ListEhrPatientLinksForReviewDocument, options);
        }
export type ListEhrPatientLinksForReviewQueryHookResult = ReturnType<typeof useListEhrPatientLinksForReviewQuery>;
export type ListEhrPatientLinksForReviewLazyQueryHookResult = ReturnType<typeof useListEhrPatientLinksForReviewLazyQuery>;
export type ListEhrPatientLinksForReviewSuspenseQueryHookResult = ReturnType<typeof useListEhrPatientLinksForReviewSuspenseQuery>;
export type ListEhrPatientLinksForReviewQueryResult = Apollo.QueryResult<ListEhrPatientLinksForReviewQuery, ListEhrPatientLinksForReviewQueryVariables>;
export const ReviewEhrPatientLinkDocument = gql`
    mutation reviewEhrPatientLink($input: ReviewEhrPatientLinkInput!) {
  reviewEhrPatientLink(input: $input) {
    id
    status
  }
}
    `;
export type ReviewEhrPatientLinkMutationFn = Apollo.MutationFunction<ReviewEhrPatientLinkMutation, ReviewEhrPatientLinkMutationVariables>;
export function useReviewEhrPatientLinkMutation(baseOptions?: Apollo.MutationHookOptions<ReviewEhrPatientLinkMutation, ReviewEhrPatientLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReviewEhrPatientLinkMutation, ReviewEhrPatientLinkMutationVariables>(ReviewEhrPatientLinkDocument, options);
      }
export type ReviewEhrPatientLinkMutationHookResult = ReturnType<typeof useReviewEhrPatientLinkMutation>;
export type ReviewEhrPatientLinkMutationResult = Apollo.MutationResult<ReviewEhrPatientLinkMutation>;
export type ReviewEhrPatientLinkMutationOptions = Apollo.BaseMutationOptions<ReviewEhrPatientLinkMutation, ReviewEhrPatientLinkMutationVariables>;
import { withMutationResponseHandler, withQueryResponseHandler } from '../hooks/useResponseHandler';
export const useListEhrSyncConnections = withQueryResponseHandler(useListEhrSyncConnectionsQuery);
export const useGetEhrSyncConnection = withQueryResponseHandler(useGetEhrSyncConnectionQuery);
export const useEhrSyncPatientLinks = withQueryResponseHandler(useEhrSyncPatientLinksQuery);
export const useEhrSyncEnrollCandidates = withQueryResponseHandler(useEhrSyncEnrollCandidatesQuery);
export const useCheckEhrZone = withQueryResponseHandler(useCheckEhrZoneQuery);
export const useListEhrPatientLinksForReview = withQueryResponseHandler(useListEhrPatientLinksForReviewQuery);
export const useUpsertEhrSyncResource = withMutationResponseHandler(useUpsertEhrSyncResourceMutation, "upsertEhrSyncResource");
export const useEnrollEhrSyncPatient = withMutationResponseHandler(useEnrollEhrSyncPatientMutation, "enrollEhrSyncPatient");
export const useSetEhrPatientLinkPaused = withMutationResponseHandler(useSetEhrPatientLinkPausedMutation, "setEhrPatientLinkPaused");
export const useUnenrollEhrSyncPatient = withMutationResponseHandler(useUnenrollEhrSyncPatientMutation, "unenrollEhrSyncPatient");
export const useRegisterEhrConnection = withMutationResponseHandler(useRegisterEhrConnectionMutation, "registerEhrConnection");
export const useReviewEhrPatientLink = withMutationResponseHandler(useReviewEhrPatientLinkMutation, "reviewEhrPatientLink");